import React from "react";
import { Result } from "antd";
import unhappy from "assets/images/unhappy.svg";
import { useTranslation } from "react-i18next";

const ProductSalesClosed = ({ message }) => {
  const { t } = useTranslation();
  const defaultMessage = message !== undefined ? message : t("productSalesClosed.defaultMessage");

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", paddingTop: 25 }}>
        <img className="img-fluid" src={"/img/logo-white.png"} alt="" />
      </div>
      <Result
        icon={<img style={{ width: "80%", maxWidth: "300px" }} src={unhappy} alt="unhappy" />}
        title={t("productSalesClosed.title")}
        subTitle={defaultMessage}
      />
    </>
  );
};

export default ProductSalesClosed;
